export class LoginModel {
    cod_usuario: string
    nome: string
    senha: string
    painel_chamados: boolean
    //painel_faturamento: boolean
    painel_financeiro: boolean
    painel_carteira: boolean
    painel_comercial: boolean
    painel_tecnica: boolean
    painel_central: boolean
    painel_vistoria_novo: boolean
    painel_vistoria: boolean
    //painel_localizacao_chamada: boolean
    painel_localizacao_tecnico: boolean
}